import { Grid, Heading } from '@zappyrent/hundop';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  StyledGridWrapper,
  StyledHeadingWrapper,
  StyledImageOuterWrapper,
  StyledTextInnerWrapper,
  StyledTextMiddleWrapper,
  StyledTextOuterWrapper,
  StyledWrapper,
} from './ReferALandlordFaq.styles';
import ReferALandlordFaqImage from './ReferALandlordFaqImage';
import ReferALandlordFaqText from './ReferALandlordFaqText';

const ReferALandlordFaq = (): JSX.Element => {
  const { t } = useTranslation(['product']);

  return (
    <StyledWrapper>
      <StyledTextOuterWrapper>
        <StyledTextMiddleWrapper>
          <StyledGridWrapper>
            <Grid container>
              <StyledTextInnerWrapper id="faq">
                <StyledHeadingWrapper>
                  <Heading sm="24px" md="24px" lg="32px" tag="h2">
                    {t('product:referALandlordFaqTitle')}
                  </Heading>
                </StyledHeadingWrapper>
                <ReferALandlordFaqText />
              </StyledTextInnerWrapper>
            </Grid>
          </StyledGridWrapper>
        </StyledTextMiddleWrapper>
        <StyledImageOuterWrapper>
          <ReferALandlordFaqImage />
        </StyledImageOuterWrapper>
      </StyledTextOuterWrapper>
    </StyledWrapper>
  );
};

export default ReferALandlordFaq;
